import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import WithSidebar from 'Layout/WithSidebar';
import Banner from 'components/Banner';
import ProductSidebar from 'components/ProductSidebar';
import BenefitsCards from 'components/BenefitsCards';
import {
    // fetchCropNutrition,
    fetchCropNutritionDetail,
    selectCropNutritionDetail,
    selectCropNutritionPage,
} from 'store/slices/CropNutritionSlice';
import { useParams } from 'react-router-dom';
import GeneralInfoBox from 'components/GeneralInfoBox';

const DetailedOfCropNutrition = () => {
    const dispatch = useDispatch();
    const { slug } = useParams();

    const {
        title,
        fs_view_button,
        fs_background,
        purpose_processing,
        detailed_data,
        purposes = [],
    } = useSelector(selectCropNutritionDetail);

    const { crops = [] } = useSelector(selectCropNutritionPage);
    const sidebarCrops = crops.filter(item => item.slug !== slug);

    useEffect(() => {
        // @ts-ignore
        // dispatch(fetchCropNutrition());
        // @ts-ignore
        dispatch(fetchCropNutritionDetail({ slug }));
    }, [dispatch, slug]);

    return (
        <>
            <Banner title={title} image={fs_background} buttonText={fs_view_button} />
            <section className="container">
                <WithSidebar
                    containerType="type-1"
                    mobileReversed
                    Sidebar={<ProductSidebar title="!!!" data={sidebarCrops} />}
                >
                    <GeneralInfoBox>
                        <div dangerouslySetInnerHTML={{ __html: detailed_data }} />
                        {purpose_processing && <h3>{purpose_processing}</h3>}
                        {purposes.length && <BenefitsCards data={purposes} withCustomContent />}
                    </GeneralInfoBox>
                </WithSidebar>
            </section>
        </>
    );
};

export default DetailedOfCropNutrition;
